import React from 'react';
import classnames from 'classnames/bind';
import { Editor } from '@tinymce/tinymce-react';

import Label from '../Label';
import FieldErrors from '../FieldErrors';

import styles from './styles.scss';

export default class HtmlEditor extends React.Component {

    constructor() {
        super();

        this._handleChange = this._handleChange.bind(this);
    }

    _getEditorClassNames() {
        const cx = classnames.bind(styles);

        return cx({
            'editor': true,
            'editor--error': this.props.meta.invalid
        });
    }

    _handleChange(content) {
        this.props.input.onChange(content);
    }

    render() {

        // Filter out props supplied by react-redux-form Field component
        const { label, required, input, meta: { touched, error }, disabled, ...allProps } = this.props;

        const inputId = `${input.name}_input`;

        return (
            <div>
                <Label text={label} htmlFor={inputId} required={required}>
                    <div id="editor-toolbar"></div>
                    <Editor
                        id={inputId}
                        aria-required={required}
                        className={this._getEditorClassNames()}
                        apiKey="n0gp9incq86gwtea16xrlm377ctgjztl3ciaba3m1u4jj2rb"
                        cloudChannel="5-stable"
                        inline={true}
                        disabled={disabled}
                        value={input.value}
                        textareaName={input.name}
                        init={{
                            menubar: true,
                            toolbar_persist: true,
                            toolbar_sticky: false,
                            fixed_toolbar_container: '#editor-toolbar',
                            contextmenu: 'link',
                            powerpaste_word_import: 'prompt',
                            powerpaste_html_import: 'prompt',
                            paste_as_text: false,
                            plugins: [
                                'advlist autolink lists link image charmap anchor',
                                'searchreplace visualblocks code fullscreen, textcolor',
                                'insertdatetime media paste code help wordcount powerpaste'
                            ],
                            toolbar:
                                'undo redo | formatselect | bold italic | \
                                alignleft aligncenter alignright alignjustify | \
                                bullist numlist outdent indent | anchor | removeformat'
                        }}
                        onEditorChange={this._handleChange}
                    />

                </Label>

                {touched && error && <FieldErrors errors={error} />}
            </div>
        )
    }
}
